import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getStudents, LeadCards } from "../../../services/admin.services";
import { ClipLoader } from "react-spinners"; // Import spinner
import { getLeadSummary } from "../../../services/lead.services";

function Dashboard_Header() {
  const [storedUser, setStoredUser] = useState(null);

  const [stats, setStats] = useState({
    enquiries: 0,
    enquiryLeads: 0,
  });

  const [isExpanded, setIsExpanded] = useState(true); // Expand state

  const [application, setApplication] = useState({
    total_applications: 0,
    Complete: 0,
  });

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  const user = useSelector((state) => state.user.userDetails);
  const invoices = useSelector((state) => state.invoice.invoices);
  const pendingInvoice = invoices.filter(
    (invoice) => invoice.status === "Pending"
  ).length;

  const tasks = useSelector((state) => state.dashboard.tasks);
  const pendingTask = tasks.filter(
    (task) => task.task_status === "pending"
  ).length;
  useEffect(() => {
    if (user && user.username) {
      localStorage.setItem("user", JSON.stringify(user));
      setStoredUser(user);
    } else {
      const savedUser = localStorage.getItem("user");
      if (savedUser) {
        setStoredUser(JSON.parse(savedUser));
      }
    }
  }, [user]);

  const fetchData = async () => {
    try {
      const response = await getLeadSummary();
      const { summary } = response.data;
      setStats({
        total_lead: summary.total_lead || 0,
        enquiryLeads: summary.fresh_to_enquiries || 0,
      });
    } catch (err) {
      console.error("Error fetching metrics:", err);
      setError("Failed to fetch metrics.");
    } finally {
      setLoading(false);
    }
  };

  const fetchStudents = async () => {
    try {
      const response = await getStudents();
      setApplication({
        total_applications: response.data.Total_Application || 0,
        Complete: response.data.Complete || 0,
      });
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  useEffect(() => {
    fetchData();

    fetchStudents();
  }, []);

  const capitalizeFullName = (fullName = "") => {
    return fullName
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <div className="flex flex-wrap px-4 md:px-6 py-4">
      <div className="flex flex-col items-start justify-center w-full">
        <div className="flex items-center mb-4 md:mb-0">
          {/* <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-700 mr-4 font-bold text-xl">
            {storedUser?.username?.charAt(0).toUpperCase() || "U"}
          </div> */}
          <div>
            <p className="text-slate-500 text-sm md:text-base font-medium tracking-wide">
              {getGreeting()}
            </p>
            <h1 className="text-2xl md:text-3xl font-bold text-slate-800">
              {capitalizeFullName(storedUser?.username) || "User"}
            </h1>
          </div>
        </div>

        {/* Toggle Button */}
        <div className="flex justify-end w-full">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-slate-600 text-sm md:text-base bg-slate-100 hover:bg-slate-200 transition-colors rounded-lg px-3 py-1.5"
          >
            {isExpanded ? "Hide ▲" : "Show ▼"}
          </button>
        </div>
      </div>

      {/* Only show cards when isExpanded is true */}
      {isExpanded && (
        <div className="mt-6 w-full">
          {loading ? (
            <div className="flex justify-center items-center w-full h-40">
              <ClipLoader size={50} color="#4A90E2" />
            </div>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5 w-full">
              <div className="bg-gradient-to-br from-emerald-500 to-emerald-600 p-4 rounded-2xl shadow-lg shadow-emerald-500/20 border border-emerald-400/30">
                <p className="text-lg font-semibold text-white/90">Leads</p>
                <h3 className="text-3xl font-bold text-white mt-2">
                  {stats.total_lead}
                </h3>
              </div>
              <div className="bg-gradient-to-br from-sky-500 to-indigo-500 p-4 rounded-2xl shadow-lg shadow-sky-500/20 border border-sky-300/30">
                <p className="text-lg font-semibold text-white">
                  Leads → Enquiries
                </p>
                <h3 className="text-3xl font-bold text-white mt-2">
                  {stats.enquiryLeads}
                </h3>
                <p className="text-xs text-white/90 mt-2">
                  Converted enquiries from leads.
                </p>
              </div>
              <div className="bg-gradient-to-br from-teal-600 to-emerald-700 p-4 flex flex-col rounded-2xl shadow-lg shadow-emerald-700/20 border border-emerald-500/30 text-white">
                <p className="text-lg font-semibold">Applications</p>
                <div className="flex justify-around">
                  <div className="flex items-center flex-col space-x-4">
                    <h3 className="text-4xl font-bold">
                      {application.total_applications}
                    </h3>
                    <p className="text-sm">In Process</p>
                  </div>
                  <div className="flex items-center flex-col space-x-4">
                    <h3 className="text-4xl font-bold">
                      {application.Complete}
                    </h3>
                    <p className="text-sm">Completed</p>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-br from-rose-500 to-pink-500 p-4 rounded-2xl shadow-lg shadow-rose-500/20 border border-rose-300/30">
                <p className="text-lg font-semibold text-white">Pending Invoices</p>
                <h3 className="text-3xl font-bold text-white mt-2">
                  {pendingInvoice}
                </h3>
              </div>
              <div className="bg-gradient-to-br from-violet-500 to-indigo-500 p-4 rounded-2xl shadow-lg shadow-violet-500/20 border border-violet-300/30">
                <p className="text-lg font-semibold text-white">Pending Task</p>
                <h3 className="text-3xl font-bold text-white mt-2">{pendingTask}</h3>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Dashboard_Header;
